import { render, staticRenderFns } from "./liveOrderDetails.vue?vue&type=template&id=22d2be77&scoped=true&"
import script from "./liveOrderDetails.vue?vue&type=script&lang=js&"
export * from "./liveOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d2be77",
  null
  
)

export default component.exports